import { createSlice } from "@reduxjs/toolkit";
// import storage from "../../services/storage";

//const token = storage.get("classToken") || "";

const initialState = {
  reader: {
    topScroll: 0,
    dragScroll: 0,
    chapter: 0,
    section: 0,
    openActivity: {},
  },
};

const slice = createSlice({
  name: "reader",
  initialState,

  reducers: {
    setTopScroll: (state, action) => {
      state.reader.topScroll = action.payload;
    },
    setChapter: (state, action) => {
      state.reader.chapter = action.payload;
    },
    resetChapter: (state) => {
      state.reader.chapter = initialState.reader.chapter;
    },
    setSection: (state, action) => {
      state.reader.section = action.payload;
    },
    resetSection: (state) => {
      state.reader.section = initialState.reader.section;
    },
    setDragScroll: (state, action) => {
      state.reader.dragScroll = action.payload;
    },
    resetDragScroll: (state) => {
      state.reader.section = initialState.reader.dragScroll;
    },
    setOpenActivity: (state, action) => {
      state.reader.openActivity = action.payload;
    },
  },
});

export const {
  setTopScroll,
  setChapter,
  setSection,
  setDragScroll,
  setOpenActivity,
} = slice.actions;
export default slice.reducer;
